import { render, staticRenderFns } from "./CodRejections.vue?vue&type=template&id=d6507da0&"
import script from "./CodRejections.vue?vue&type=script&lang=js&"
export * from "./CodRejections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports